'use client';

var __jsx = React.createElement;
import React, { forwardRef } from 'react';
import 'styles/components/buttons/labeled-icon-button.css';
const LabeledIconButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    label,
    icon,
    onClick = () => {},
    labelClassName = '',
    buttonClassName = 'flex',
    labelColor = 'currentColor',
    iconPosition = 'start',
    // Default to 'start'
    dataTestId
  } = _ref;
  return __jsx("div", {
    ref: ref,
    className: "labeled-icon-button clickable items-center  ".concat(buttonClassName),
    onClick: () => onClick(),
    "data-testid": dataTestId
  }, iconPosition === 'start' && icon && __jsx("div", {
    className: "labeled-icon-button-icon"
  }, icon), __jsx("div", {
    className: "labeled-icon-button-label ".concat(labelClassName),
    style: {
      color: labelColor
    }
  }, label), iconPosition === 'end' && icon && __jsx("div", {
    className: "labeled-icon-button-icon  mt-1",
    style: {
      color: labelColor
    }
  }, icon));
});
LabeledIconButton.displayName = 'LabeledIconButton';
export default LabeledIconButton;